import styled from 'styled-components';
import { UIElements } from '@ansvar-sakerhet/ui';

const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 10px;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: 5px;
  min-width: 200px;
  max-width: 280px;
  flex: 1;
  background-color: ${({ theme }) => theme.colors.white};
`;

const SearchInput = styled.input`
  border: none;
  font-size: 14px;
  outline: none;
  width: 100%;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.black};

  &::placeholder {
    color: ${({ theme }) => theme.colors.darkGray};
  }
`;

const ClearButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.darkGray};

  &:hover {
    color: ${({ theme }) => theme.colors.black};
  }
`;

const ClearFiltersButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

export const S = {
  ...UIElements,
  FiltersContainer,
  SearchContainer,
  SearchInput,
  ClearButton,
  ClearFiltersButton,
};
